/**
 * @file index.tsx
 * @module app/modules/setting/index
 * @description Route container for the Setting module. Defines breadcrumbs,
 * default redirect, and page route for the Setting page.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.9
 * @version 1.3.5
 */

import { Navigate, Route, Routes } from 'react-router-dom';
import { PageLink, PageTitle } from '../../../_admin/layout/core';
import SettingPage from './page';
const settingsBreadCrumbs: Array<PageLink> = [
  {
    title: 'Settings',
    path: '/setting',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];

/**
 * Setting module router.
 * @returns {JSX.Element} Routes for the setting module.
 */
const SettingPages = () => {
  return (
    <Routes>
      <Route
        path="*"
        element={<Navigate to="/error/404" />}
      />
      <Route
        index
        element={<Navigate to="/setting/page" />}
      />
      <Route
        path="page"
        element={
          <>
            <PageTitle breadcrumbs={settingsBreadCrumbs}>Settings</PageTitle>
            <SettingPage />
          </>
        }
      />
    </Routes>
  );
};
export default SettingPages;
